import mitt from "mitt";
const bus = mitt();
export {
  bus as default
};
